// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"xn-z","outfitFeedbackSection":"yn-z"};